// Libs
import React from 'react';
import cx from 'classnames';

// Hooks
import { useDispatch, useSelector } from 'react-redux';
import useTranslator from 'UTILS/hooks/useTranslator';

// Components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

// Actions
import { goToPermissionsInfo, leaveClick } from 'REDUCERS/navSlice';

// Utils
import { useTheme } from '@material-ui/core/styles';
import { NARROW_LAYOUT } from 'UTILS/constants';
import { onTrackedClick } from 'UTILS/callbacks';
import translations from './locales.json';

const Intro = () => {
  const [translate] = useTranslator(translations);
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useSelector(state => state.app.layout === NARROW_LAYOUT);
  const shouldShowBackButton = useSelector(state => state.app.backUrl || state.app.closeOnBack);

  const handleNotNowClick = () => {
    onTrackedClick('back', 'intro');
    dispatch(leaveClick());
  };

  const handleGoClick = () => {
    onTrackedClick('start', 'intro');
    dispatch(goToPermissionsInfo());
  };

  const boxStyles = {
    display: isSmallScreen ? 'block' : 'flex',
    flexDirection: isSmallScreen ? null : 'column',
    alignItems: isSmallScreen ? null : 'center',
    marginBottom: '35px',
  };

  const containerClasses = cx('intro-container', {
    'intro-container_largerScreen': !isSmallScreen,
  });

  const whiteBackground = theme.palette.background.paper;

  return (
    <Box className={containerClasses} bgcolor={isSmallScreen ? whiteBackground : null} >
      <Box bgcolor={!isSmallScreen ? whiteBackground : null} className='intro-surface' >
        {isSmallScreen && (
          <img src={theme.assets.appLogo} alt='logo acetiam' className='intro-smallLogo' />
        )}
        <Typography align='center' variant='h5'>
          <Box component='span' fontWeight='bold' >
            {translate('testMyHardware')}
          </Box>
        </Typography>
        <img src={theme.assets.titleLogo} alt='logo custom' className='intro-bigLogo' />
        <Container maxWidth={isSmallScreen ? 'md' : 'sm'} >
          <Box {...boxStyles} >
            <Typography variant='body2' paragraph color='textSecondary' className='intro-adviceMessage'>
              {translate('toEnsureQualityVideoConsultationAndExchangesWeRecommendThatYouTestYourEquipmentYouWillBeAbleToCheckTheTechnicalCompatibilityOfYourToolsWithTheVideoConsultation')}
            </Typography>
            <Box className={isSmallScreen ? null : 'intro-containerButton'} >
              <Button variant='contained' size='large' color='primary' fullWidth onClick={handleGoClick}>
                {translate('letUsGo')}
              </Button>
            </Box>
          </Box>
        </Container>
        {shouldShowBackButton && (
          <Button variant='text' onClick={handleNotNowClick} color='primary'>
            {translate('notNow')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Intro;
